import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function EditIndentDrug() {

  const {id}=useParams();
  const [errorMsg, seterrorMsg] = useState('');
  const [succesMsg, setsuccessMsg] = useState('');
  const [manus,setManus] = useState([]);
  const [dists,setDists] = useState([]);
  const [registerFormData, setRegisterFormData] = useState({
        "qty":'',
        "addedby":'',
        "ip_add":'',
    });
    useEffect(() => {
        try{
            axios.get(baseUrl+'update-indent-use/'+id+'/')
            .then(function (response) {
                setRegisterFormData({
                    qty:response.data.qty,
                    product:response.data.product,
                });
            });
        }catch(error){
            console.log(error);
        }
    },[]);

   const handleChange = (event) => {
      setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        });
  };

  const submitHandler = (e) => {
     e.preventDefault();

        const formData = new FormData();
        formData.append('product',registerFormData.product);
        formData.append('qty',registerFormData.qty);
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

        axios.put(baseUrl+'update-indent-use/'+id+'/', formData)
          .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Qty has been Updated.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/indent-drug-list/';
                }, 3000);
              }
            })
              .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add drug. Please try again later.',
                    'error'
                  );
              });
  };

  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>Edit Drug</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>

                        <div className="row">

                        <div className="col-md-2 mb-3">
                            <label htmlFor="Product" className="form-label">Product</label>
                            <input type="number" maxLength={10} placeholder="Product" className="form-control"
                                name="product" value={registerFormData.product} onChange={handleChange} readOnly />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="TQty" className="form-label">TQty</label>
                            <input type="number" maxLength={10} placeholder="TQty" className="form-control"
                                name="qty" value={registerFormData.qty} onChange={handleChange} />
                        </div>
                        </div>

                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" onClick={submitHandler}
                        className="btn btn-success">Update</button>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default EditIndentDrug;
